export default {
  products: 'products',
  salesman: 'salesman',
  outlets: 'outlet-revenue',
  payment: 'payment-methods',
  cashiers: 'cashiers',
  registers: 'registers',
  totalRevenues: 'total-revenues',
  saleSummary: 'sale-summary',
  categories: 'categories',
  productSold: 'product-sold',
  productSoldCategories: 'product-sold-categories',
  fulfillment: 'fulfillment-summary',
  orders: 'orders',
  averageDuration: 'order-duration',
  orderStatus: 'order-status',
  paymentStatus: 'payment-status',
  productProfit: 'product-profit',
  globalReport: 'global-report',
  timeInStatus: 'order-time-in-status',
  tippings: 'tippings',
  usePaginations: ['products', 'order-duration', 'product-profit', 'order-time-in-status', 'orders', 'product-sold', 'tippings'],
  orderStatusFields: 'id,store_id,register_id,created_at,customer_first_name,customer_last_name,order_number,status,grand_total,currency,currency_exchange_rate,base_currency',
  saleSummaryOrderFields: 'number_of_orders',
  revenuaTab: ['total-revenue', 'net-revenue', 'revenue-by-customer', 'revenue-by-outlet', 'seller', 'cashier', 'revenue-by-category', 'sales-report', 'payment'],
  ordersTab: ['number-of-orders', 'average-order-value', 'average-item-per-order', 'refund', 'discount', 'fulfillment', 'payment-status', 'order-status', 'average-duration', 'time-in-status']
}
